import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { createSvgIcon } from "@mui/material/utils";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Dialog, FormControlLabel, FormGroup } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import DialogTitle from "@mui/material/DialogTitle";
import { DateTimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "../css/table.css";
import Checkbox from "@mui/material/Checkbox";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import moment from "moment";
import "moment/locale/ko";

function createData(sid, name, terminal, users) {
  return {
    sid,
    name,
    terminal,
    users,
  };
}

const PlusIcon = createSvgIcon(
  // credit: plus icon from https://heroicons.com/
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </svg>,
  "Plus"
);

function Row(props) {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const apiUrl = process.env.REACT_APP_API;
  const { row, data } = props;
  const [open, setOpen] = useState(false);
  const [click, setClick] = useState(false);
  const [selectedRowSid, setSelectedRowSid] = useState(null);
  const dataArray = Array.isArray(data) ? data : [];
  const [name, setName] = useState(""); // 담당자 이름
  const [department, setDepartment] = useState(""); // 부서
  const [subject, setSubject] = useState(""); // 내용
  const [startTime, setStartTime] = useState(null); // 시작시간
  const [endTime, setEndTime] = useState(null); // 종료시간
  const [phoneNumber, setPhoneNumber] = useState("");
  const [guid, setGuid] = useState("");
  const [checked, setChecked] = useState(false);
  const [createTimed, setCreateTimed] = useState(null);
  const [createUserId, setCreateUserId] = useState("");
  const [email, setEmail] = useState("");
  const [noteCheck, setNoteCheck] = useState(false);
  const [beamCheck, setBeamCheck] = useState(false);

  const flagChange = (event) => {
    setChecked(event.target.checked);
  };
  const beamChange = (event) => {
    setBeamCheck(event.target.checked);
  };
  const noteChange = (event) => {
    setNoteCheck(event.target.checked);
  };

  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;

    // 숫자만 남기고 나머지 문자 제거
    input = input.replace(/\D/g, "");

    // 번호를 하이픈(-)으로 포맷
    if (input.length > 4 && input.length <= 8) {
      input = input.replace(/(\d{3})(\d+)/, "$1-$2");
    } else if (input.length > 7 && input.startsWith("032")) {
      input = input.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
    } else if (input.length > 8) {
      input = input.replace(/(\d{3})(\d{4})(\d+)/, "$1-$2-$3");
    }

    setPhoneNumber(input);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}${month}${day}`;
  };

  const handleSubmit = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const currentDate = new Date();
    const oneWeekLater = new Date(
      currentDate.getTime() + 6 * 24 * 60 * 60 * 1000
    ); // 현재로부터 7일 후

    const convertLater = formatDate(oneWeekLater);
    const startDt = formatDate(new Date(startTime));
    const endDt = formatDate(new Date(endTime));

    if (email === "" || !emailPattern.test(email)) {
      alert("올바른 이메일 주소를 입력하세요");
    } else if (
      (startDt > convertLater || endDt > convertLater) &&
      sessionStorage.getItem("id") !== "AACTIT" &&
      sessionStorage.getItem("id") !== "AACTHR"
    ) {
      alert("일주일 이후 예약은 불가능합니다.");
    } else {
      const requestData = {
        reservationSid: guid,
        roomSid: selectedRowSid,
        reservationPart: department,
        reservationName: name,
        reservationPhone: phoneNumber,
        reservationSubject: subject,
        reservationStartTime: startTime,
        reservationEndTime: endTime,
        usableFlag: "Y",
        createUserId:
          createUserId === "" ? sessionStorage.getItem("id") : createUserId,
        approveFlag: "Y",
        executiveFlag: checked ? "Y" : "N",
        createdTime: createTimed === null ? null : createTimed,
        userEmail: email,
        notebookFlag: noteCheck ? "Y" : "N",
        beamFlag: beamCheck ? "Y" : "N",
      };

      fetch(`${apiUrl}/mr/reservation`, {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (!response.ok) {
            console.log(response.json);
          }

          window.location.replace("/reservation");
          return response.json(); // 서버 응답을 JSON으로 파싱
        })
        .then((responseData) => {
          alert("예약되었습니다.");
        })
        .catch((error) => {
          // 오류 처리 (네트워크 오류 또는 서버 오류 등)
          console.error("Error:", error);
        });
    }
  };

  const approve = (sid) => {
    fetch(`${apiUrl}/mr/approve?sid=${sid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        alert("승인되었습니다.");
        window.location.replace("/reservation");
        return response.json(); // 서버 응답을 JSON으로 파싱
      })
      .then(() => {})
      .catch((error) => {
        // 오류 처리 (네트워크 오류 또는 서버 오류 등)
        console.error("Error:", error);
      });
  };

  const remove = (rowSid) => {
    fetch(`${apiUrl}/mr/removeMeet?sid=${rowSid}`, {
      method: "Delete",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        window.location.replace("/reservation");
        return response.json(); // 서버 응답을 JSON으로 파싱
      })
      .then((responseData) => {
        alert("삭제되었습니다.");
      })
      .catch((error) => {
        // 오류 처리 (네트워크 오류 또는 서버 오류 등)
        console.error("Error:", error);
      });
  };

  const openChange = (rowSid) => {
    fetch(`${apiUrl}/mr/searchSid?sid=${rowSid}`)
      .then((response) => response.json())
      .then((res) => {
        res.map((item) => {
          setGuid(item.reservationSid);
          setSelectedRowSid(item.roomSid);
          setName(item.reservationName);
          setDepartment(item.reservationPart);
          setSubject(item.reservationSubject);
          setPhoneNumber(item.reservationPhone);
          setStartTime(dayjs(item.reservationStartTime));
          setEndTime(dayjs(item.reservationEndTime));
          setChecked(item.executiveFlag === "Y");
          setCreateTimed(item.createdTime);
          setCreateUserId(item.createUserId);
          setEmail(item.userEmail);
          setNoteCheck(item.notebookFlag === "Y");
          setBeamCheck(item.beamFlag === "Y");
        });
      });

    setClick(true);
  };

  const handleClose = () => {
    setGuid("");
    setSelectedRowSid(null);
    setName("");
    setDepartment("");
    setSubject("");
    setPhoneNumber("");
    setStartTime(dayjs(null));
    setEndTime(dayjs(null));
    setChecked(false);
    setCreateTimed(null);
    setCreateUserId("");
    setEmail("");
    setClick(false);
    setBeamCheck(false);
    setNoteCheck(false);
  };
  const handleClickOpen = (rowSid) => {
    setSelectedRowSid(rowSid);
    setClick(true);
  };

  return (
    <React.Fragment>
      <TableRow key={row.sid} sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell>{row.terminal}</TableCell>
        <TableCell>{row.users}</TableCell>
        <TableCell>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#0C4876" }}
            onClick={(e) => {
              handleClickOpen(row.sid);
              e.stopPropagation();
            }}
            disabled={row.sid === 1}
          >
            예약하기
          </Button>

          <Dialog
            open={click}
            PaperProps={{ style: { width: "35%", maxWidth: "none" } }}
          >
            <DialogTitle>예약하기</DialogTitle>

            <DialogContent>
              <Grid container spacing={5}>
                <Grid item xs={12} sm={3}>
                  <TextField
                    required
                    id="name"
                    name="name"
                    label="담당자"
                    fullWidth
                    variant="standard"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    required
                    id="name"
                    name="name"
                    label="부서"
                    fullWidth
                    variant="standard"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="phone"
                    name="phone"
                    label="전화번호"
                    fullWidth
                    variant="standard"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    inputProps={{
                      maxLength: 13, // 하이픈 포함 최대 길이
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="subject"
                    name="subject"
                    label="사유"
                    fullWidth
                    variant="standard"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DateTimePicker"]}>
                      <DateTimePicker
                        label="시작시간"
                        value={startTime}
                        onChange={(value) => setStartTime(value)}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DateTimePicker"]}>
                      <DateTimePicker
                        label="종료시간"
                        value={endTime}
                        onChange={(value) => setEndTime(value)}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <FormControlLabel
                      label="임원참석여부"
                      control={
                        <Checkbox checked={checked} onChange={flagChange} />
                      }
                    />
                    <FormControlLabel
                      label="빔프로젝트사용여부"
                      control={
                        <Checkbox checked={beamCheck} onChange={beamChange} />
                      }
                    />
                    <FormControlLabel
                      label="노트북사용여부"
                      control={
                        <Checkbox checked={noteCheck} onChange={noteChange} />
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="email"
                    name="email"
                    label="이메일"
                    fullWidth
                    variant="standard"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleSubmit}>Subscribe</Button>
            </DialogActions>
          </Dialog>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0.5 }}>
              <Typography variant="h6" gutterBottom component="div">
                예약정보
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontSize: "12px" }}>신청날짜</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>부서</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>담당자</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>전화번호</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>예약시간</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>승인여부</TableCell>
                    <TableCell style={{ fontSize: "12px" }}>삭제</TableCell>
                    {sessionStorage.getItem("authority") === "Y" ? (
                      <TableCell style={{ fontSize: "12px" }}>승인</TableCell>
                    ) : (
                      ""
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataArray.map(
                    (item, index) =>
                      item && (
                        <TableRow
                          onClick={(e) => {
                            e.stopPropagation(); // 클릭 이벤트 버블링 막음
                            openChange(item.reservationSid);
                          }}
                          key={index}
                          hover
                        >
                          <TableCell
                            style={{ fontSize: "12px" }}
                            component="th"
                            scope="row"
                          >
                            {item.createdTime ? (
                              <>
                                {moment(item.createdTime).format("MM-DD HH:mm")}
                              </>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          <TableCell style={{ fontSize: "12px" }}>
                            {item.reservationPart}
                          </TableCell>
                          <TableCell style={{ fontSize: "12px" }}>
                            {item.reservationName}
                          </TableCell>
                          <TableCell style={{ fontSize: "12px" }}>
                            {item.reservationPhone}
                          </TableCell>
                          <TableCell style={{ fontSize: "12px" }}>
                            {item.reservationStartTime &&
                            item.reservationEndTime ? (
                              <>
                                {moment(item.reservationStartTime).format(
                                  "MM-DD HH:mm"
                                )}
                                {" / "}
                                {moment(item.reservationEndTime).format(
                                  "MM-DD HH:mm"
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "12px", textAlign: "center" }}
                          >
                            {item.approveFlag === "A"
                              ? "완료"
                              : item.approveFlag === "Y"
                              ? "대기"
                              : "취소"}
                          </TableCell>

                          <TableCell>
                            {sessionStorage.getItem("id") ===
                              item.createUserId ||
                            sessionStorage.getItem("authority") === "Y" ? (
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  remove(item.reservationSid);
                                }}
                              >
                                <DeleteOutlinedIcon />
                              </IconButton>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          {sessionStorage.getItem("authority") === "Y" &&
                          item.approveFlag !== "A" ? (
                            <TableCell>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  approve(item.reservationSid);
                                }}
                              >
                                <AssignmentTurnedInIcon />
                              </IconButton>
                            </TableCell>
                          ) : (
                            ""
                          )}
                        </TableRow>
                      )
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
// selectedSlot;

Row.propTypes = {
  row: PropTypes.shape({
    sid: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    terminal: PropTypes.string.isRequired,
    users: PropTypes.number.isRequired,
  }).isRequired,
};

const CollapsibleTable = ({ data }) => {
  const [counts, setCounts] = useState([]);
  const apiUrl = process.env.REACT_APP_API;
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  useEffect(() => {
    fetch(`${apiUrl}/mr/count`, requestOptions)
      .then((response) => response.json())
      .then((res) => {
        setCounts(res);
      });
  }, []);

  const rows = [
    createData(2, "2F 대회의실", "T2", counts[1]),
    createData(1, "2F 교육장", "T1", counts[0]),
    //createData(3, "3F 대회의실", "T1", counts[2]),
  ];

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>회의실</TableCell>
            <TableCell>터미널</TableCell>
            <TableCell>예약인원</TableCell>
            <TableCell sx={{ paddingLeft: "23px" }}> 예약하기</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const matchingData = Array.isArray(data)
              ? data.filter((item) => item.roomSid === row.sid)
              : null;

            return <Row key={row.sid} row={row} data={matchingData || {}} />;
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTable;
